<template>
    <div class="table-time-card text-primary"
         min-width="230"
         :width="width ? width : 230"
         @click="selectedTask = task; editDateTime = true">
        <template v-if="startTime && duration">
            <v-card-title class="d-flex justify-space-between">
                <span>{{startTime}} - {{endTime}}</span>
                <span>&nbsp;({{duration}})</span>
            </v-card-title>
        </template>
        <template v-else-if="startTime">
            <v-card-title>
                {{startTime}} - ...
            </v-card-title>
        </template>
        <template v-else-if="duration">
            <v-card-title class="d-flex justify-end">
                ({{duration}})
            </v-card-title>
        </template>
        <template v-else>
            <v-card-title class="d-flex justify-center">
                <v-icon v-if="alternativeIcon"
                        :icon="alternativeIcon"
                        :title="alternativeText" />
                <span v-else>{{alternativeText}}</span>
            </v-card-title>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            startTime: String,
            endTime: String,
            duration: String,

            alternativeText: String,
            alternativeIcon: String,
            width: String
        }
    };
</script>

<style lang="scss">
    .table-time-card {
        border-color: rgba(var(--v-theme-primary));
        border-style: solid;
        border-width: 0;
        border-bottom-width: 1px;
    }
</style>